import { useCallback } from 'react';
import { useUpdateMissionControlFiltersMutation } from './useUpdateMissionControlFiltersMutation';

export type TrackFiltersProps = {
  datePreset?: string;
  campaignLabelIds?: number[];
  messageTypeIds?: number[];
};

export const useTrackFilters = (
  labelIds: number[],
  messageTypeIds: number[],
  dateRangePreset: string,
) => {
  const { mutate: updateMissionControlFilters } = useUpdateMissionControlFiltersMutation();

  const trackFilters = useCallback(
    (filters: TrackFiltersProps) => {
      updateMissionControlFilters({
        datePreset: dateRangePreset,
        campaignLabelIds: labelIds,
        messageTypeIds,
        ...filters,
      });
    },
    [labelIds, messageTypeIds, dateRangePreset, updateMissionControlFilters],
  );

  return { trackFilters };
};
